/**
 * A segmented control: a row of mutually exclusive choices on one track.
 * `mode="radio"` is a form choice (radiogroup / radio, aria-checked);
 * `mode="toggle"` switches a view (group of aria-pressed buttons).
 * Options are { value, label, title? }.
 */

const SIZES = {
  xs: "h-7 px-2.5 text-[11px]",
  sm: "h-8 px-3 text-[11.5px]",
  md: "h-9 px-3.5 text-[12px]",
};

export function Segmented({ options, value, onChange, label, mode = "toggle", size = "sm", block = false, className = "" }) {
  const radio = mode === "radio";
  return (
    <div
      role={radio ? "radiogroup" : "group"}
      aria-label={label}
      className={`${block ? "flex w-full" : "inline-flex"} flex-wrap items-center gap-0.5 rounded-full bg-surface-2 p-1 ring-1 ring-line ring-inset ${className}`}
    >
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value || "_all"}
            type="button"
            role={radio ? "radio" : undefined}
            aria-checked={radio ? on : undefined}
            aria-pressed={radio ? undefined : on}
            title={o.title}
            onClick={() => onChange(o.value)}
            className={`${block ? "flex-1" : ""} inline-flex items-center justify-center rounded-full font-medium whitespace-nowrap transition-[background-color,color,box-shadow] duration-150 ${SIZES[size] ?? SIZES.sm} ${
              on ? "bg-ink text-white shadow-[0_1px_2px_rgb(16_24_40/0.2)]" : "text-ink-3 hover:text-ink"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
